import { getData } from 'conversations-async-data/async-data/operators/getters';
// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module 'conv... Remove this comment to see the full error message
import ThreadToolbarPlaceholder from 'conversations-thread-view/thread-toolbar/components/ThreadToolbarPlaceholder';
import { getFormattedContactDetail } from '../../operators/ticketToContactAssociationGetters';
import { getFirstName, getLastName, getEmail, getVid, getPhone, getCompany, getAssociatedCompanyId, getAssociatedCompanyName } from 'conversations-inbox-lib/contacts/public/operators';
import { isLoading } from 'conversations-async-data/async-data/operators/statusComparators';
import { isKnownContact as isKnownContactOperator } from '../../../contacts/operators/isKnownContact';
import TicketHeader from 'svh-workspace-ui-lib/ticket-header/public/TicketHeader';
import { trackEvent } from '../../../usage-tracking/clients/usageTracker';
import AssociateContactToThreadButton from '../AssociateContactToThreadButton';
import { jsx as _jsx } from "react/jsx-runtime";
const InboxTicketHeader = ({
  threadId,
  ticket,
  children,
  asyncContact
}) => {
  const contact = getData(asyncContact);
  const vid = getVid(contact);
  const contactEmail = getEmail(contact);
  const contactPhone = getPhone(contact);
  const company = getCompany(contact);
  const isKnownContact = isKnownContactOperator(contact);
  const loadingThreadHeader = isLoading(asyncContact);
  const firstName = getFirstName(contact);
  const lastName = getLastName(contact);
  const associatedCompanyId = getAssociatedCompanyId(contact);
  const associatedCompanyName = getAssociatedCompanyName(contact);
  const contactDetail = getFormattedContactDetail(firstName, lastName, contactEmail, contactPhone);
  if (loadingThreadHeader) {
    return /*#__PURE__*/_jsx("div", {
      role: "heading",
      "aria-level": 1,
      "aria-busy": "true",
      children: /*#__PURE__*/_jsx(ThreadToolbarPlaceholder, {})
    });
  }
  return /*#__PURE__*/_jsx(TicketHeader, {
    contactDetail: contactDetail || '',
    contactEmail: contactEmail || '',
    company: company || '',
    associatedCompanyId: associatedCompanyId || '',
    associatedCompanyName: associatedCompanyName || '',
    isKnownContact: isKnownContact,
    ticket: ticket,
    threadId: threadId,
    vid: vid,
    trackEvent: trackEvent,
    renderAssociateContactButton: () => /*#__PURE__*/_jsx(AssociateContactToThreadButton, {
      threadId: threadId
    }),
    children: children
  });
};
InboxTicketHeader.displayName = 'InboxTicketHeader';
export default InboxTicketHeader;